import type { ReactNode } from 'react'

export type CautionProps = {
  title?: string
  severity?: 'warning' | 'critical'
  children: ReactNode
}

export default function Caution({ title = 'Caution', severity = 'warning', children }: CautionProps) {
  return (
    <aside className={`slide-caution slide-caution--${severity}`} data-archetype="caution">
      <div className="slide-caution__header">
        <span className="slide-caution__icon" aria-hidden="true">
          {severity === 'critical' ? '⛔' : '⚠️'}
        </span>
        <strong>{title}</strong>
      </div>
      <div className="slide-caution__body">{children}</div>
    </aside>
  )
}
